/**
 * The names of the app themes. A theme sets the colors through the CSS variables of `src/styles/app-themes.css`
 * and the look of the buttons through `BUTTON_LOOKS` in `buttonLooks.ts`.
 *
 * Rule: the presenter view always shows "original".
 */
export const APP_THEMES = ["original", "terminal"] as const;

export type AppTheme = (typeof APP_THEMES)[number];

export const DEFAULT_APP_THEME: AppTheme = "original";

export const APP_THEME_LABELS: Record<AppTheme, string> = {
    original: "Original",
    terminal: "Terminal",
};

/** The localStorage key of the theme store. `index.html` reads it before the first paint. */
export const APP_THEME_STORAGE_KEY = "zwennie-app-theme";
